"use client";

import { c as _c } from "react/compiler-runtime";
import { ChakraProvider } from "@chakra-ui/react";
import { ColorModeProvider, type ColorModeProviderProps } from "./color-mode";
import system from "../../../styles/theme";
export function Provider(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ChakraProvider value={system}><ColorModeProvider forcedTheme="light" {...props} /></ChakraProvider>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}

// NOTE: below are alternate snippets in case the one above doesn't work as expected

// // TODO: this is (close to?) the original code from Chakra v2; it doesn't seem to work properly at all b/c there are no styles applied to the components ... may be b/c there is no longer a `@chakra-ui/next-js` to import from

// import { ChakraProvider } from "@chakra-ui/react";
// import system from "../../../styles/theme";

// export function Provider({
//   children,
//   ...props
// }: {
//   children: React.ReactNode;
// }) {
//   return (
//     <ChakraProvider value={system} {...props}>
//       {children}
//     </ChakraProvider>
//   );
// }

// // TODO: this is a v3 snippet from this sandbox: https://github.com/chakra-ui/chakra-ui/blob/main/sandbox/next-app/app/provider.tsx; seems to work similarly to the first snippet without studying too carefully
// import { ChakraProvider } from "@chakra-ui/react";

// import { ThemeProvider } from "next-themes";
// // import { ColorModeProvider, type ColorModeProviderProps } from "./color-mode";
// import system from "../../../styles/theme";

// export default function Provider(props: { children: React.ReactNode }) {
//   return (
//     <ChakraProvider value={system}>
//       <ThemeProvider attribute="class" disableTransitionOnChange>
//         {props.children}
//       </ThemeProvider>
//     </ChakraProvider>
//   );
// }